import type { Options } from "@/types/OptionsTypes";
import { BaseHttpService } from "@/api/http/BaseHttpService";
import { OPTIONS_FILE_MAPPING } from "@/constants/files";

export const optionsEndpoints = {
  options: "borrower_platform/options",
} as const;

export class OptionsHttpService extends BaseHttpService {
  screenLoadingPaths = [];

  async getOptions() {
    const { data } = await this.get<{ data: Options }>(optionsEndpoints.options, {
      params: { file_mapping: OPTIONS_FILE_MAPPING },
    });
    return data;
  }
}
